var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6C3.25 3.37665 5.37665 1.25 8 1.25H16C18.6234 1.25 20.75 3.37665 20.75 6V18C20.75 20.6234 18.6234 22.75 16 22.75H8C5.37665 22.75 3.25 20.6234 3.25 18V6ZM7.25 7C7.25 6.0335 8.0335 5.25 9 5.25H15C15.9665 5.25 16.75 6.0335 16.75 7V8C16.75 8.9665 15.9665 9.75 15 9.75H9C8.0335 9.75 7.25 8.9665 7.25 8V7ZM9.75 18C9.75 18.4142 9.41421 18.75 9 18.75H8C7.58579 18.75 7.25 18.4142 7.25 18C7.25 17.5858 7.58579 17.25 8 17.25H9C9.41421 17.25 9.75 17.5858 9.75 18ZM9 14.75C9.41421 14.75 9.75 14.4142 9.75 14C9.75 13.5858 9.41421 13.25 9 13.25H8C7.58579 13.25 7.25 13.5858 7.25 14C7.25 14.4142 7.58579 14.75 8 14.75H9ZM14.25 18C14.25 17.5858 14.5858 17.25 15 17.25H16C16.4142 17.25 16.75 17.5858 16.75 18C16.75 18.4142 16.4142 18.75 16 18.75H15C14.5858 18.75 14.25 18.4142 14.25 18ZM15 13.25C14.5858 13.25 14.25 13.5858 14.25 14C14.25 14.4142 14.5858 14.75 15 14.75H16C16.4142 14.75 16.75 14.4142 16.75 14C16.75 13.5858 16.4142 13.25 16 13.25H15Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.08894d2fada9e7d975540686960fb3f9.svg";
export { ForwardRef as ReactComponent };